/* eslint-disable import/prefer-default-export */
import { Streams } from '../../../Types';
import { AlertActions, AlertsActionTypes } from '../../Alerts/actions';

export const alertCreatedHandler = (event: Streams.AlertCreatedEvent, dispatch): void => {
    dispatch({
        type: AlertActions.ADD_ALERT,
        payload: {
            message: event.message,
        },
    } as AlertsActionTypes);
};
